// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"274d6bf4","453":"9537af23","565":"b8c1fe0d","587":"c2f1d1a2"}[chunkId] + ".chunk.js";
};